// extracted by mini-css-extract-plugin
module.exports = {"block":"block-3ce570","block_active":"block_active-3ce570","bg":"bg-3ce570","contour":"contour-3ce570","icon":"icon-3ce570"};